import { BaseRouteState } from './routing/types';

export const normalizeRefinements = (refinements: Partial<BaseRouteState>) => {
    const updatedRefinements: Partial<BaseRouteState> = {};

    for (const [key, value] of Object.entries(refinements)) {
        if (!value || key === 'page') continue;

        const list = Array.isArray(value) ? value : [value];

        // Remove duplicates from refinement list values
        const refinementList = list.slice().sort((a, b) => {
            return a.toString().toLowerCase().localeCompare(b.toString().toLowerCase());
        });
        const normalizedRefinementList = refinementList
            .filter((item, index) => {
                return (
                    index === 0 || item.toString().toLowerCase() !== refinementList[index - 1].toString().toLowerCase()
                );
            })
            .map((item) => decodeURIComponent(item.toString()))
            .map((item) => {
                return item.replace(/\+/g, ' ').split(' ').join(' ');
            });

        updatedRefinements[key] = normalizedRefinementList;
    }

    if (refinements.page) {
        updatedRefinements.page = Number(refinements.page);
    }

    return updatedRefinements;
};
